import ImpresCartDrawer from './ImpresCartDrawer'

// Needed because the cart must reach the nav bar's icon on any page, not just the IMPRES
// page so this can't live inside ImpresCatalog.tsx. Kept separate from NavBar/routes.tsx
// so NavBar stays generic and routes.tsx stays focused on routing, not feature UI.
export default function ImpresCartOverlay() {
  return <ImpresCartDrawer />
}
